import {
  eChatEventErrorCodes,
  eChatEventStatus,
  eChatEventTypes,
} from '../../providers/SocketsProvider/Sockets.enums.ts';
import {
  tChatEvent as tChatEventSocket,
  tMessageErrorType,
} from '../../providers/SocketsProvider/Sockets.types.ts';
import { EventType, MessageErrorType, MessageState } from './Chat.enum.ts';

import { tChatEvent } from './Chat.types.ts';
import { toChatEventErrors } from './chatEventErrors.functions.ts';

export default function chatUtils() {
  function castState(state: eChatEventStatus | undefined) {
    switch (state) {
      case eChatEventStatus.CREATED:
      case eChatEventStatus.PENDING:
        return MessageState.SEND_PENDING;
      case eChatEventStatus.SENDING:
        return MessageState.SENDING;
      case eChatEventStatus.SENT:
        return MessageState.SENT;
      case eChatEventStatus.DELIVERY:
        return MessageState.DELIVERED;
      case eChatEventStatus.READ:
        return MessageState.READ;
      case eChatEventStatus.ERROR:
        return MessageState.ERROR;
      default:
        return MessageState.SEND_PENDING;
    }
  }

  function parseErrors(errors: tMessageErrorType[] | undefined) {
    if (!errors || errors.length === 0 || !errors[0].code)
      return MessageErrorType.NO_ERROR;
    switch (errors[0].code) {
      case eChatEventErrorCodes.PROVIDER_SEND_ERROR:
        return MessageErrorType.PROVIDER_SEND_ERROR;
      case eChatEventErrorCodes.UNKNOWN_ERROR_FROM_PROVIDER:
        return MessageErrorType.UNKNOWN_ERROR_FROM_PROVIDER;
      case eChatEventErrorCodes.MESSAGE_NOT_SUPPORTED:
        return MessageErrorType.MESSAGE_NOT_SUPPORTED;
      case eChatEventErrorCodes.MESSAGE_DECRYPTION_ERROR:
        return MessageErrorType.MESSAGE_DECRYPTION_ERROR;
      case eChatEventErrorCodes.MESSAGE_NOT_FOUND_ON_PROVIDER:
        return MessageErrorType.MESSAGE_NOT_FOUND_ON_PROVIDER;
      case eChatEventErrorCodes.MESSAGE_REJECTED_BY_PROVIDER:
        return MessageErrorType.MESSAGE_REJECTED_BY_PROVIDER;
      case eChatEventErrorCodes.EMPTY_MESSAGE_ERROR:
        return MessageErrorType.EMPTY_MESSAGE_ERROR;
      case eChatEventErrorCodes.MESSAGE_WINDOW_CLOSED:
        return MessageErrorType.MESSAGE_WINDOW_CLOSED;
      case eChatEventErrorCodes.RECIPIENT_UNAVAILABLE:
        return MessageErrorType.RECIPIENT_UNAVAILABLE;
      case eChatEventErrorCodes.AUTH_INVALID_TOKEN_ERROR:
        return MessageErrorType.AUTH_INVALID_TOKEN_ERROR;
      case eChatEventErrorCodes.MEDIA_UPLOAD_ERROR:
        return MessageErrorType.MEDIA_UPLOAD_ERROR;
      case eChatEventErrorCodes.WORKSPACE_PLAN_PAUSED:
        return MessageErrorType.WORKSPACE_PLAN_PAUSED;
      case eChatEventErrorCodes.SENDER_WORKSPACE_MISMATCH:
        return MessageErrorType.SENDER_WORKSPACE_MISMATCH;
      case eChatEventErrorCodes.SENDER_WORKSPACE_UNRESOLVABLE:
        return MessageErrorType.SENDER_WORKSPACE_UNRESOLVABLE;
      case eChatEventErrorCodes.ERROR_RECIPIENT_NOT_FOUND_ON_WHATSAPP:
        return MessageErrorType.ERROR_RECIPIENT_NOT_FOUND_ON_WHATSAPP;
      case eChatEventErrorCodes.PINNED_MESSAGE_NOTIFICATION_NOT_SUPPORTED:
        return MessageErrorType.PINNED_MESSAGE_NOTIFICATION_NOT_SUPPORTED;
      case eChatEventErrorCodes.PLACEHOLDER_MESSAGE_NOT_SUPPORTED:
        return MessageErrorType.PLACEHOLDER_MESSAGE_NOT_SUPPORTED;
      case eChatEventErrorCodes.TEMPLATE_MESSAGE_NOT_SUPPORTED:
        return MessageErrorType.TEMPLATE_MESSAGE_NOT_SUPPORTED;
      case eChatEventErrorCodes.INTERACTIVE_MESSAGE_NOT_SUPPORTED:
        return MessageErrorType.INTERACTIVE_MESSAGE_NOT_SUPPORTED;
      case eChatEventErrorCodes.LOTTIE_STICKER_NOT_SUPPORTED:
        return MessageErrorType.LOTTIE_STICKER_NOT_SUPPORTED;
      case eChatEventErrorCodes.GROUP_MENTION_IN_STATUS_NOTIFICATION_NOT_SUPPORTED:
        return MessageErrorType.GROUP_MENTION_IN_STATUS_NOTIFICATION_NOT_SUPPORTED;
      case eChatEventErrorCodes.GROUP_INVITE_MESSAGE_NOT_SUPPORTED:
        return MessageErrorType.GROUP_INVITE_MESSAGE_NOT_SUPPORTED;
      case eChatEventErrorCodes.DEVICE_SENT_MESSAGE_NOT_SUPPORTED:
        return MessageErrorType.DEVICE_SENT_MESSAGE_NOT_SUPPORTED;
      case eChatEventErrorCodes.COMMUNITY_ANNOUNCEMENT_COMMENT_NOT_SUPPORTED:
        return MessageErrorType.COMMUNITY_ANNOUNCEMENT_COMMENT_NOT_SUPPORTED;
      case eChatEventErrorCodes.OTHER_MESSAGE_TYPE_NOT_SUPPORTED:
        return MessageErrorType.OTHER_MESSAGE_TYPE_NOT_SUPPORTED;
      case eChatEventErrorCodes.WHATSAPP_WEB_ACCOUNT_DISCONNECTED:
        return MessageErrorType.WHATSAPP_WEB_ACCOUNT_DISCONNECTED;
      case eChatEventErrorCodes.WHATSAPP_WEB_NEW_CHAT_LIMIT_REACHED:
        return MessageErrorType.WHATSAPP_WEB_NEW_CHAT_LIMIT_REACHED;
      case eChatEventErrorCodes.META_INACTIVITY_WINDOW_EXPIRED:
        return MessageErrorType.META_INACTIVITY_WINDOW_EXPIRED;
      case eChatEventErrorCodes.META_SEND_UNCONFIRMED:
        return MessageErrorType.META_SEND_UNCONFIRMED;
      case eChatEventErrorCodes.WAPI_RETRY_UNCONFIRMED:
        return MessageErrorType.WAPI_RETRY_UNCONFIRMED;
      case eChatEventErrorCodes.META_MESSAGE_TOO_LONG:
        return MessageErrorType.META_MESSAGE_TOO_LONG;
      case eChatEventErrorCodes.META_ATTACHMENT_UNSUPPORTED:
        return MessageErrorType.META_ATTACHMENT_UNSUPPORTED;
      case eChatEventErrorCodes.META_ATTACHMENT_UPLOAD_FAILED:
        return MessageErrorType.META_ATTACHMENT_UPLOAD_FAILED;
      case eChatEventErrorCodes.META_THREAD_CONTROL_LOST:
        return MessageErrorType.META_THREAD_CONTROL_LOST;
      case eChatEventErrorCodes.META_ATTACHMENT_FETCH_FAILED:
        return MessageErrorType.META_ATTACHMENT_FETCH_FAILED;
      case eChatEventErrorCodes.META_ATTACHMENT_TOO_LARGE:
        return MessageErrorType.META_ATTACHMENT_TOO_LARGE;
      case eChatEventErrorCodes.WAPI_CREDIT_CARD_EXPIRED_ERROR:
        return MessageErrorType.WAPI_CREDIT_CARD_EXPIRED_ERROR;
      case eChatEventErrorCodes.WAPI_API_UNKNOWN_ERROR:
        return MessageErrorType.WAPI_API_UNKNOWN_ERROR;
      case eChatEventErrorCodes.WAPI_SERVICE_UNAVAILABLE_ERROR:
        return MessageErrorType.WAPI_SERVICE_UNAVAILABLE_ERROR;
      case eChatEventErrorCodes.WAPI_INVALID_PARAM_VALUE_ERROR:
        return MessageErrorType.WAPI_INVALID_PARAM_VALUE_ERROR;
      case eChatEventErrorCodes.WAPI_INVALID_PARAMETER_ERROR:
        return MessageErrorType.WAPI_INVALID_PARAMETER_ERROR;
      case eChatEventErrorCodes.WAPI_ACCESS_TOKEN_ERROR:
        return MessageErrorType.WAPI_ACCESS_TOKEN_ERROR;
      case eChatEventErrorCodes.WAPI_PERMISSION_ERROR:
        return MessageErrorType.WAPI_PERMISSION_ERROR;
      case eChatEventErrorCodes.WAPI_TEMPORARILY_BLOCKED_ERROR:
        return MessageErrorType.WAPI_TEMPORARILY_BLOCKED_ERROR;
      case eChatEventErrorCodes.WAPI_UNKNOWN_ERROR:
        return MessageErrorType.WAPI_UNKNOWN_ERROR;
      case eChatEventErrorCodes.WAPI_GENERAL_FAILURE_ERROR:
        return MessageErrorType.WAPI_GENERAL_FAILURE_ERROR;
      case eChatEventErrorCodes.WAPI_ACCESS_DENIED_ERROR:
        return MessageErrorType.WAPI_ACCESS_DENIED_ERROR;
      case eChatEventErrorCodes.WAPI_MISSING_PARAMETER_ERROR:
        return MessageErrorType.WAPI_MISSING_PARAMETER_ERROR;
      case eChatEventErrorCodes.WAPI_SERVICE_UNAVAILABLE_ERROR_2:
        return MessageErrorType.WAPI_SERVICE_UNAVAILABLE_ERROR_2;
      case eChatEventErrorCodes.WAPI_RECIPIENT_SENDER_CONFLICT_ERROR:
        return MessageErrorType.WAPI_RECIPIENT_SENDER_CONFLICT_ERROR;
      case eChatEventErrorCodes.WAPI_MESSAGE_UNDELIVERABLE_ERROR:
        return MessageErrorType.WAPI_MESSAGE_UNDELIVERABLE_ERROR;
      case eChatEventErrorCodes.WAPI_DISCONNECTED_ACCOUNT_ERROR:
        return MessageErrorType.WAPI_DISCONNECTED_ACCOUNT_ERROR;
      case eChatEventErrorCodes.WAPI_DISPLAY_NAME_PENDING_ERROR:
        return MessageErrorType.WAPI_DISPLAY_NAME_PENDING_ERROR;
      case eChatEventErrorCodes.WAPI_BUSINESS_ISSUE_ERROR:
        return MessageErrorType.WAPI_BUSINESS_ISSUE_ERROR;
      case eChatEventErrorCodes.WAPI_CERTIFICATE_ERROR:
        return MessageErrorType.WAPI_CERTIFICATE_ERROR;
      case eChatEventErrorCodes.WAPI_REENGAGEMENT_REQUIRED_ERROR:
        return MessageErrorType.WAPI_REENGAGEMENT_REQUIRED_ERROR;
      case eChatEventErrorCodes.WAPI_RATE_LIMITED_ERROR:
        return MessageErrorType.WAPI_RATE_LIMITED_ERROR;
      case eChatEventErrorCodes.WAPI_SEND_RATE_LIMITED_ERROR:
        return MessageErrorType.WAPI_SEND_RATE_LIMITED_ERROR;
      case eChatEventErrorCodes.WAPI_OUTBOUND_MEDIA_UPLOAD_ERROR:
        return MessageErrorType.WAPI_OUTBOUND_MEDIA_UPLOAD_ERROR;
      case eChatEventErrorCodes.WAPI_HEALTHY_ENGAGEMENT_ERROR:
        return MessageErrorType.WAPI_HEALTHY_ENGAGEMENT_ERROR;
      case eChatEventErrorCodes.WAPI_USER_STOPPED_MARKETING_ERROR:
        return MessageErrorType.WAPI_USER_STOPPED_MARKETING_ERROR;
      case eChatEventErrorCodes.WAPI_UNSUPPORTED_MESSAGE_TYPE_ERROR:
        return MessageErrorType.WAPI_UNSUPPORTED_MESSAGE_TYPE_ERROR;
      case eChatEventErrorCodes.WAPI_EDITED_MESSAGE_ERROR:
        return MessageErrorType.WAPI_EDITED_MESSAGE_ERROR;
      case eChatEventErrorCodes.WAPI_GENERIC_UNSUPPORTED_MESSAGE_ERROR:
        return MessageErrorType.WAPI_GENERIC_UNSUPPORTED_MESSAGE_ERROR;
      case eChatEventErrorCodes.WAPI_MEDIA_DOWNLOAD_ERROR:
        return MessageErrorType.WAPI_MEDIA_DOWNLOAD_ERROR;
      case eChatEventErrorCodes.WAPI_MEDIA_UPLOAD_ERROR:
        return MessageErrorType.WAPI_MEDIA_UPLOAD_ERROR;
      case eChatEventErrorCodes.WAPI_PAIR_RATE_LIMIT_ERROR:
        return MessageErrorType.WAPI_PAIR_RATE_LIMIT_ERROR;
      case eChatEventErrorCodes.WAPI_CONCURRENCY_LIMIT_ERROR:
        return MessageErrorType.WAPI_CONCURRENCY_LIMIT_ERROR;
      case eChatEventErrorCodes.WAPI_TEMPLATE_PARAM_COUNT_ERROR:
        return MessageErrorType.WAPI_TEMPLATE_PARAM_COUNT_ERROR;
      case eChatEventErrorCodes.WAPI_TEMPLATE_NOT_APPROVED_ERROR:
        return MessageErrorType.WAPI_TEMPLATE_NOT_APPROVED_ERROR;
      case eChatEventErrorCodes.WAPI_HYDRATED_TEXT_TOO_LONG_ERROR:
        return MessageErrorType.WAPI_HYDRATED_TEXT_TOO_LONG_ERROR;
      case eChatEventErrorCodes.WAPI_FORMAT_POLICY_VIOLATION_ERROR:
        return MessageErrorType.WAPI_FORMAT_POLICY_VIOLATION_ERROR;
      case eChatEventErrorCodes.WAPI_PARAMETER_FORMAT_MISMATCH_ERROR:
        return MessageErrorType.WAPI_PARAMETER_FORMAT_MISMATCH_ERROR;
      case eChatEventErrorCodes.WAPI_TEMPLATE_PAUSED_ERROR:
        return MessageErrorType.WAPI_TEMPLATE_PAUSED_ERROR;
      case eChatEventErrorCodes.WAPI_TEMPLATE_DISABLED_ERROR:
        return MessageErrorType.WAPI_TEMPLATE_DISABLED_ERROR;
      case eChatEventErrorCodes.WAPI_TEMPLATE_INVALID_PARAMS_ERROR:
        return MessageErrorType.WAPI_TEMPLATE_INVALID_PARAMS_ERROR;
      case eChatEventErrorCodes.WAPI_INCOMPLETE_DEREGISTRATION_ERROR:
        return MessageErrorType.WAPI_INCOMPLETE_DEREGISTRATION_ERROR;
      case eChatEventErrorCodes.WAPI_REGISTRATION_SERVER_UNAVAILABLE_ERROR:
        return MessageErrorType.WAPI_REGISTRATION_SERVER_UNAVAILABLE_ERROR;
      case eChatEventErrorCodes.WAPI_DUPLICATE_LANGUAGE_CONTENT_ERROR:
        return MessageErrorType.WAPI_DUPLICATE_LANGUAGE_CONTENT_ERROR;
      case eChatEventErrorCodes.WAPI_TEMPLATE_LIMIT_EXCEEDED_ERROR:
        return MessageErrorType.WAPI_TEMPLATE_LIMIT_EXCEEDED_ERROR;
      case eChatEventErrorCodes.WAPI_CHARACTER_LIMIT_EXCEEDED_ERROR:
        return MessageErrorType.WAPI_CHARACTER_LIMIT_EXCEEDED_ERROR;
      case eChatEventErrorCodes.WAPI_MISSING_FIELDS_ERROR:
        return MessageErrorType.WAPI_MISSING_FIELDS_ERROR;
      case eChatEventErrorCodes.WAPI_HEADER_FORMAT_ERROR:
        return MessageErrorType.WAPI_HEADER_FORMAT_ERROR;
      case eChatEventErrorCodes.WAPI_BODY_FORMAT_ERROR:
        return MessageErrorType.WAPI_BODY_FORMAT_ERROR;
      case eChatEventErrorCodes.WAPI_FOOTER_FORMAT_ERROR:
        return MessageErrorType.WAPI_FOOTER_FORMAT_ERROR;
      case eChatEventErrorCodes.WAPI_TEMPLATE_RECENTLY_DELETED_ERROR:
        return MessageErrorType.WAPI_TEMPLATE_RECENTLY_DELETED_ERROR;
      case eChatEventErrorCodes.WAPI_POSSIBLE_UNSUPPORTED_DEVICE_ERROR:
        return MessageErrorType.WAPI_POSSIBLE_UNSUPPORTED_DEVICE_ERROR;
      case eChatEventErrorCodes.WAPI_CLOUD_API_NOT_AVAILABLE_ERROR:
        return MessageErrorType.WAPI_CLOUD_API_NOT_AVAILABLE_ERROR;
      case eChatEventErrorCodes.WAPI_HELD_FOR_QUALITY_ERROR:
        return MessageErrorType.WAPI_HELD_FOR_QUALITY_ERROR;
      // INT-1500 (contract C2). 3074 is intentionally unused.
      case eChatEventErrorCodes.WAPI_NUMBER_NOT_REGISTERED_ERROR:
        return MessageErrorType.WAPI_NUMBER_NOT_REGISTERED_ERROR;
      case eChatEventErrorCodes.WAPI_MARKETING_DISABLED_ERROR:
        return MessageErrorType.WAPI_MARKETING_DISABLED_ERROR;
      case eChatEventErrorCodes.WAPI_SCHEDULED_TEMPLATE_DELETED_ERROR:
        return MessageErrorType.WAPI_SCHEDULED_TEMPLATE_DELETED_ERROR;
      case eChatEventErrorCodes.WAPI_MARKETING_BACKOFF_ERROR:
        return MessageErrorType.WAPI_MARKETING_BACKOFF_ERROR;
      case eChatEventErrorCodes.WAPI_MARKETING_OPT_OUT_ERROR:
        return MessageErrorType.WAPI_MARKETING_OPT_OUT_ERROR;
      case eChatEventErrorCodes.WAPI_MARKETING_PAUSED_RESTRICTED_ERROR:
        return MessageErrorType.WAPI_MARKETING_PAUSED_RESTRICTED_ERROR;
      case eChatEventErrorCodes.WAPI_TEMPLATE_CREDITS_ERROR:
        return MessageErrorType.WAPI_TEMPLATE_CREDITS_ERROR;
      case eChatEventErrorCodes.WAPI_TEMPLATE_EMPTY_VARIABLES_ERROR:
        return MessageErrorType.WAPI_TEMPLATE_EMPTY_VARIABLES_ERROR;
      // RET-2257: los tres del wallet. Van separados porque la salida del
      // operador cambia en cada uno: sin saldo recarga, con el wallet caído
      // reintenta, y si no hay tarifa para el destinatario no hay reintento
      // que lo arregle.
      case eChatEventErrorCodes.WAPI_WALLET_INSUFFICIENT_BALANCE_ERROR:
        return MessageErrorType.WAPI_WALLET_INSUFFICIENT_BALANCE_ERROR;
      case eChatEventErrorCodes.WAPI_WALLET_UNAVAILABLE_ERROR:
        return MessageErrorType.WAPI_WALLET_UNAVAILABLE_ERROR;
      case eChatEventErrorCodes.WAPI_WALLET_UNPRICEABLE_ERROR:
        return MessageErrorType.WAPI_WALLET_UNPRICEABLE_ERROR;
      case eChatEventErrorCodes.WAPI_ACCOUNT_NOT_CONNECTED_ERROR:
        return MessageErrorType.WAPI_ACCOUNT_NOT_CONNECTED_ERROR;
      case eChatEventErrorCodes.WAPI_STICKER_NOT_SENDABLE_ERROR:
        return MessageErrorType.WAPI_STICKER_NOT_SENDABLE_ERROR;
      case eChatEventErrorCodes.WAPI_MESSAGE_TYPE_NOT_SENDABLE_ERROR:
        return MessageErrorType.WAPI_MESSAGE_TYPE_NOT_SENDABLE_ERROR;
      case eChatEventErrorCodes.WAPI_IMAGE_NOT_SENDABLE_ERROR:
        return MessageErrorType.WAPI_IMAGE_NOT_SENDABLE_ERROR;
      default:
        return MessageErrorType.NO_ERROR;
    }
  }

  function updateChatEvents(
    event: tChatEventSocket,
    findChatEvent: tChatEvent,
  ) {
    let typeEvent: EventType;
    switch (event.type) {
      case eChatEventTypes.MESSAGE:
        typeEvent = EventType.MESSAGE;
        break;
      case eChatEventTypes.TEMPLATE:
        typeEvent = EventType.TEMPLATE;
        break;
      case eChatEventTypes.NOTE:
        typeEvent = EventType.NOTE;
        break;
      case eChatEventTypes.FOLLOW_UP:
        typeEvent = EventType.FOLLOW_UP;
        break;
      // BUG-1063: a deletion reaches an open chat through here. Without these
      // two the default kept the event's previous type, so the bubble stayed a
      // plain message until the seller reloaded — and once the body is
      // stripped server-side, a plain message with no text is an empty bubble.
      case eChatEventTypes.OUTBOUND_DELETED:
        typeEvent = EventType.OUTBOUND_DELETED;
        break;
      case eChatEventTypes.INBOUND_DELETED:
        typeEvent = EventType.INBOUND_DELETED;
        break;
      default:
        typeEvent = findChatEvent.type || EventType.MESSAGE;
        break;
    }

    return {
      ...findChatEvent,
      type: typeEvent,
      // INT-1500 U3: a failure update carries its error rows (Meta's code and
      // details included). A plain state update carries none and must not
      // wipe the ones the event has: the scheduled card reads them (BUG-741).
      errors: event.errors?.length
        ? toChatEventErrors(event.errors)
        : findChatEvent.errors,
      content: {
        ...findChatEvent.content,
        isEdited: event.content.is_edited,
        text: event.content.text,
      },
      message: {
        ...findChatEvent.message,
        state: castState(event.state),
        // INT-1704: a state-only update (the business reading the chat on its
        // phone) carries no errors. For a notice the contact sent, that is
        // not a resolution: keep the code, or the live bubble goes empty
        // while history still shows the notice. Any other error still clears.
        error:
          !event.errors?.length &&
          findChatEvent.message?.fromMe === false &&
          isUnsupportedContentNotice(findChatEvent.message?.error)
            ? findChatEvent.message.error
            : parseErrors(event.errors),
        fromMe: !!event?.content?.from_me,
        // BUG-1063: `??`, not `||`. messaging unstars a message when it is
        // deleted, and with `||` that legitimate `false` could never win over
        // the star already on screen. `??` still falls back when the event
        // does not carry the field at all, which is what a partial update is.
        // `isForwarded` below keeps `||` on purpose: a message never stops
        // being forwarded, so there is no false to lose.
        isFavorite:
          event.is_favorite ?? findChatEvent.message?.isFavorite ?? false,
        isForwarded:
          event.content.is_forwarded ||
          findChatEvent.message?.isForwarded ||
          false,
        participant: {
          handle:
            event?.participant?.handle ||
            findChatEvent.message?.participant.handle ||
            '',
          name:
            event?.participant?.name ||
            findChatEvent.message?.participant.name ||
            '',
        },
      },
    };
  }

  return {
    castState,
    parseErrors,
    updateChatEvents,
  };
}

/**
 * BUG-704: the WAPI "unsupported subtype" codes that render as calm
 * informational notes rather than errors. Bubbles carrying one of these:
 *   - render via the dedicated note branch in MessageByContentType (no orange
 *     error line, no exclamation icon, salience-floor pill register),
 *   - are carved out of showCheckStatus (no red delivery-status ping on echoes),
 *   - hide the per-message affordances (reply/star/forward/delete/react) because
 *     there is no real content to quote, forward, or react to.
 * 3050 (WAPI_UNSUPPORTED_MESSAGE_TYPE_ERROR) is intentionally NOT here: it keeps
 * the existing error rail with rewritten honest copy.
 */
const WAPI_UNSUPPORTED_INFO_NOTE_ERRORS: ReadonlySet<string> = new Set([
  MessageErrorType.WAPI_EDITED_MESSAGE_ERROR,
  MessageErrorType.WAPI_GENERIC_UNSUPPORTED_MESSAGE_ERROR,
]);

export function isWapiUnsupportedInfoNote(error: string | undefined): boolean {
  return !!error && WAPI_UNSUPPORTED_INFO_NOTE_ERRORS.has(error);
}

/**
 * INT-1704: content the chat cannot show, named by code: 1004 (any channel;
 * WhatsApp Web polls and orders, Messenger and Instagram per INT-1696),
 * 2001–2009 (WhatsApp Web types) and 2012 (any other WhatsApp Web type,
 * INT-1700; it reads the INT-1690 inbound copy). For the contact's own messages
 * (`fromMe === false`) MessageByContentType paints a calm note in the body
 * with the inbound copy, in any state, and MessageBubbleV2 drops the rail so
 * 1004 is said once. The business side is untouched.
 * Deliberately separate from isWapiUnsupportedInfoNote, which also hides the
 * message menu and the reaction button (KTD1).
 */
const UNSUPPORTED_CONTENT_NOTICE_ERRORS: ReadonlySet<string> = new Set([
  MessageErrorType.MESSAGE_NOT_SUPPORTED,
  MessageErrorType.PINNED_MESSAGE_NOTIFICATION_NOT_SUPPORTED,
  MessageErrorType.PLACEHOLDER_MESSAGE_NOT_SUPPORTED,
  MessageErrorType.TEMPLATE_MESSAGE_NOT_SUPPORTED,
  MessageErrorType.INTERACTIVE_MESSAGE_NOT_SUPPORTED,
  MessageErrorType.LOTTIE_STICKER_NOT_SUPPORTED,
  MessageErrorType.GROUP_MENTION_IN_STATUS_NOTIFICATION_NOT_SUPPORTED,
  MessageErrorType.GROUP_INVITE_MESSAGE_NOT_SUPPORTED,
  MessageErrorType.DEVICE_SENT_MESSAGE_NOT_SUPPORTED,
  MessageErrorType.COMMUNITY_ANNOUNCEMENT_COMMENT_NOT_SUPPORTED,
  MessageErrorType.OTHER_MESSAGE_TYPE_NOT_SUPPORTED,
]);

export function isUnsupportedContentNotice(error: string | undefined): boolean {
  return !!error && UNSUPPORTED_CONTENT_NOTICE_ERRORS.has(error);
}

/**
 * INT-1500 (contract C2): sends Leadsales refused before they reached Meta:
 * the scheduled template was deleted, the per-lead marketing back-off or the
 * lead's opt-out, marketing paused while the number is restricted, no template
 * credits, or empty lead variables. The bubble keeps what it tried to send and
 * explains itself with its own "ours" notice (resolveLeadsalesRefusalNotice,
 * INT-1500 U7), never with the legacy card that replaces the content.
 */
const LEADSALES_TEMPLATE_REFUSALS: ReadonlySet<string> = new Set([
  MessageErrorType.WAPI_SCHEDULED_TEMPLATE_DELETED_ERROR,
  MessageErrorType.WAPI_MARKETING_BACKOFF_ERROR,
  MessageErrorType.WAPI_MARKETING_OPT_OUT_ERROR,
  MessageErrorType.WAPI_MARKETING_PAUSED_RESTRICTED_ERROR,
  MessageErrorType.WAPI_TEMPLATE_CREDITS_ERROR,
  MessageErrorType.WAPI_TEMPLATE_EMPTY_VARIABLES_ERROR,
]);

export function isLeadsalesTemplateRefusal(error: string | undefined): boolean {
  return !!error && LEADSALES_TEMPLATE_REFUSALS.has(error);
}

export function getModuleName() {
  if (typeof window === 'undefined') return '/';

  const path = window.location.pathname;
  if (!path) return '/';

  const segments = path.split('/');
  const module = segments[2];

  if (!module) return '/';

  return module.charAt(0).toUpperCase() + module.slice(1);
}
